import { render } from "./QaTasks.vue?vue&type=template&id=3a069104&scoped=true"
import script from "./QaTasks.vue?vue&type=script&lang=js"
export * from "./QaTasks.vue?vue&type=script&lang=js"

import "./QaTasks.vue?vue&type=style&index=0&id=3a069104&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a069104"]])

export default __exports__